import { css } from "styled-components";
import { colorMixin, spacingMixin } from "../../helpers";
import { IAppTheme } from "../../types";
import { TTableVariant } from "./types";

export type TTableStyles = {
    cellPaddingX: string;
    cellPaddingY: string;
    cellBottomBorder: string;
    headCellColor: ReturnType<typeof css>;
    headCellPadding: string;
    headBackground: ReturnType<typeof css>;
    tableBackground: ReturnType<typeof css>;
    tableBorder: string;
    headCellSortableColor: ReturnType<typeof css>;
};

export const getTableStyles = (
    theme: IAppTheme,
    variant: TTableVariant,
    withoutContainerStyles?: boolean
): TTableStyles => {
    switch (variant) {
        case "inset":
            return {
                cellPaddingX: spacingMixin(1.5),
                cellPaddingY: spacingMixin(1),
                cellBottomBorder: `1px solid ${theme.v2.colors["primary-base"]}`,
                headCellColor: colorMixin("text-primary-700"),
                headCellPadding: spacingMixin(1.5),
                headBackground: colorMixin("transparaent"),
                tableBackground: colorMixin("primary-50", 0.6),
                tableBorder: `none`,
                headCellSortableColor: colorMixin("text-primary-700")
            };
        case "default":
        default:
            return {
                cellPaddingX: spacingMixin(1.5),
                cellPaddingY: spacingMixin(1),
                cellBottomBorder: `1px solid ${theme.v2.colors["border-primary-100"]}`,
                headCellColor: colorMixin("text-primary-700"),
                headCellPadding: spacingMixin(1.5),
                headBackground: colorMixin("background-primary-50"),
                tableBackground: colorMixin("background-primary-base"),
                tableBorder: withoutContainerStyles ? "none" : `1px solid ${theme.v2.colors["border-primary-100"]}`,
                headCellSortableColor: colorMixin("surface-900")
            };
    }
};
